import { Fragment } from 'react'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import type { selectProductDescription } from '@/selectors/user.selectors'
import { DeviceWidth, useIsDeviceWidth } from '@/utils/deviceWidthHelpers'
import { TypographyStyles } from '@/styles'
import {
  Accordion,
  Card,
  CardColors,
  Icon,
  Link,
  List,
  Text,
  Tooltip,
} from '@/ui'

export const DetailsAccordion = ({
  productDescription,
  hideTitle,
  forOneTimePayment = false,
}: {
  productDescription: ReturnType<typeof selectProductDescription>
  hideTitle?: boolean
  forOneTimePayment?: boolean
}) => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)

  return (
    <Accordion
      type="single"
      collapsible
      variant="text"
      className={`w-full ${isMobile ? 'mb-8' : 'mb-4'}`}
    >
      <Accordion.Item value="details">
        <Accordion.Trigger>
          <Text
            variant={
              isMobile ? TypographyStyles.BODY_SM : TypographyStyles.BODY_MD
            }
          >
            {forOneTimePayment ? 'See Details' : 'Plan Details'}
          </Text>
        </Accordion.Trigger>

        <Accordion.Content>
          <Card
            color={CardColors.LEVEL_1}
            className={`w-full ${isMobile ? 'px-3.5' : ''}`}
          >
            {productDescription
              ?.filter(({ isVisible }) => isVisible)
              .map(({ title, details }) => (
                <Fragment key={title}>
                  {!hideTitle && (
                    <div className="flex items-center gap-2">
                      <Text
                        variant={
                          isMobile ? TypographyStyles.H2 : TypographyStyles.H1
                        }
                        className="font-normal mb-2"
                      >
                        {title}
                      </Text>
                    </div>
                  )}

                  <List className="pr-3">
                    {details.map((item) => (
                      <List.Item
                        key={item.text}
                        className="mb-4 flex items-center"
                      >
                        <Icon
                          icon={regular('check')}
                          color="text-green-100"
                          className="mr-4 inline-block"
                        />

                        {item.tooltip && (
                          <Tooltip>
                            <Tooltip.Trigger>
                              <Link
                                variant="secondary"
                                href=""
                                onClick={(e) => e.preventDefault()}
                                className="inline-block pr-2.5"
                              >
                                {item.text}
                              </Link>
                            </Tooltip.Trigger>

                            <Tooltip.Content>{item.tooltip}</Tooltip.Content>
                          </Tooltip>
                        )}
                      </List.Item>
                    ))}
                  </List>
                </Fragment>
              ))}
          </Card>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion>
  )
}
